var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderComponent'),_c('div',{staticClass:"hero-wrapper"},[_c('TituloHero'),_c('CarouselComponent')],1),_c('EspecialidadesComponent'),_c('v-divider',{staticClass:"mt-0 mb-16",attrs:{"thickness":"2","color":"#2e7d32"}}),_c('CardsComponent'),_c('FooterComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }